import React from "react";
import styled from 'styled-components';
import { VerticalAd } from "./VerticalAd";
import AboutPublisher from "./AboutPublisher";

const Container = styled.div`
  display: flex;
  align-items: center;
  margin: 0 auto;
  margin-bottom: 30px;
`;

export const PublisherSection = () => {
  return (
    <Container>
      <VerticalAd imageUrl={`${process.env.PUBLIC_URL}/media/vertical_ad.png`} />
      
      <AboutPublisher />

      <VerticalAd imageUrl={`${process.env.PUBLIC_URL}/media/vertical_ad.png`} />
    </Container>
  );
};
